import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getAiClientChat } from './myPageApi';

// 메시지의 화자를 정한다. speaker(counselor/client)를 우선 쓰고, 없으면 role(user=상담자)로 판단한다.
function isCounselor(message) {
    return message.speaker ? message.speaker === 'counselor' : message.role === 'user';
}

// 한 번 불러온 대화록은 화면을 떠나기 전까지 다시 요청하지 않도록 보관한다.
const chatCache = new Map();

// 면담 대화록. 펼칠 때 GET /api/mypage/ai-client-activity/:instanceId/chat을 호출한다.
export default function ChatTranscript({ id, instanceId, clientName }) {
    const [chat, setChat] = useState(() => chatCache.get(instanceId) || null);
    const [error, setError] = useState('');

    // 대화록을 불러와 캐시와 상태에 넣는다.
    const load = useCallback(async () => {
        setError('');
        try {
            const data = await getAiClientChat(instanceId);
            chatCache.set(instanceId, data);
            setChat(data);
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [instanceId]);

    useEffect(() => { if (!chatCache.has(instanceId)) load(); }, [instanceId, load]);

    if (error) return <div id={id} role="alert"><p className="my-page-field-error">{error}</p><button type="button" className="my-page-button my-page-retry" onClick={load}>다시 시도</button></div>;
    if (!chat) return <p id={id} className="my-page-notice" role="status">대화록을 불러오고 있습니다.</p>;

    const messages = chat.messages.filter(message => message.content);
    if (messages.length === 0) return <p id={id} className="my-page-notice">아직 나눈 대화가 없습니다.</p>;

    return <div id={id} className="my-page-dialogue" role="log" aria-label={`${clientName} 님과의 대화록`}>
        {messages.map(message => {
            const counselor = isCounselor(message);
            return <div key={message.id} className={counselor ? 'counselor' : undefined}><strong>{counselor ? '나 · 상담자' : clientName}</strong><p>{message.content}</p></div>;
        })}
    </div>;
}

ChatTranscript.propTypes = {
    id: PropTypes.string.isRequired,
    instanceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    clientName: PropTypes.string.isRequired,
};
